/**
 * @license
 * Copyright 2018-2022 Streamlit Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { fontSizes } from "./typography"

export const spacing = {
  halfSmFont: `${fontSizes.smPx / 2}px`,
  twoThirdsSmFont: `${(fontSizes.smPx * 2) / 3}px`,
  px: "1px",
  none: "0",
  threeXS: "0.125rem",
  twoXS: "0.25rem",
  xs: "0.375rem",
  sm: "0.5rem",
  md: "0.75rem",
  lg: "1rem",
  xl: "1.25rem",
  twoXL: "1.5rem",
  threeXL: "2rem",
  fourXL: "4rem",
}
